import { useEffect, useState } from 'react';
import { getAttendances } from '../services';
import { mockUserData } from '../../tests/mock/userMock';

const convertStatusToPortuguese = (status: string) => {
  const dictionary = {
    new: 'Novo',
    open: 'Aberto',
    waiting: 'Em espera',
    pending: 'Pendente',
    solved: 'Resolvido',
    closed: 'Fechado',
  };

  return dictionary[status as keyof typeof dictionary] ?? status;
};

function sortByDate(isAsc: boolean, data: Attendance[]) {
  const compareDates = (a: Attendance, b: Attendance) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    if (dateA < dateB) return isAsc ? 1 : -1;
    if (dateA > dateB) return isAsc ? -1 : 1;
    return 0;
  };
  return data.slice().sort(compareDates);
}

function sortByDateAsc(data: Attendance[]): Attendance[] {
  return sortByDate(true, data);
}

function sortByDateDesc(data: Attendance[]): Attendance[] {
  return sortByDate(false, data);
}

function sortByStatus(data: Attendance[]): Attendance[] {
  const compareStatus = (a: Attendance, b: Attendance) => {
    return convertStatusToPortuguese(a.status).localeCompare(convertStatusToPortuguese(b.status));
  };
  return [...data.sort(compareStatus)];
}

function sortBySubject(data: Attendance[]) {
  const compareSubject = (a: Attendance, b: Attendance) => {
    return a.subject.localeCompare(b.subject);
  };
  return [...data.sort(compareSubject)];
}

const sortList = {
  dateAsc: sortByDateAsc,
  dateDesc: sortByDateDesc,
  status: sortByStatus,
  subject: sortBySubject,
};
export type SortType = keyof typeof sortList;
export type Attendance = {
  // eslint-disable-next-line camelcase
  created_at: string;
  number: string;
  status: string;
  subject: string;
  id: string;
  isOpened: boolean;
};

export function useUserData(apiDomain: string) {
  const [userData, setUserData] = useState<Attendance[]>([]);
  const [userDataLoading, setUserDataLoading] = useState(true);
  const vbzDebug = localStorage.getItem('vbzDebug');

  useEffect(() => {
    if (vbzDebug) {
      const newUserDataSorted = sortList.dateAsc([...mockUserData] as Attendance[]);
      setUserData(newUserDataSorted);
      setUserDataLoading(false);
    } else {
      getAttendances(apiDomain)
        .then(data => setUserData(sortList.dateAsc(data)))
        .catch(console.error)
        .finally(() => setUserDataLoading(false));
    }
  }, []);

  function sortData(sortType: SortType) {
    const sortedData = sortList[sortType](userData);
    setUserData(sortedData);
  }
  return { userData, userDataLoading, sortData };
}
